import { makeStyles } from '@material-ui/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  selector: {
    marginTop: '1rem',
    textAlign: 'center',
    borderTop: `1px solid ${neutral[30]}`,
  },
  btn: {
    height: '2.75rem',
    width: '2.75rem',
  },
  icon: {
    height: '1.25rem',
    width: '1.75rem',
  },
  version: {
    fontWeight: 500,
    fontSize: '0.75rem',
    color: neutral[100],
  },
});
